import { Control } from 'react-hook-form'
import { Flex } from 'antd'
import { InvoiceFormValues } from './schema'
import CheckboxField from 'ui/forms/fields/CheckboxField'

interface InvoiceActionFieldsProps {
  control: Control<InvoiceFormValues>
}

const InvoiceActionFields = ({ control }: InvoiceActionFieldsProps) => {
  return (
    <Flex gap="1rem" wrap="wrap" align='center'>
      <div className="">Mark as:</div>
      <CheckboxField
        control={control}
        name={'paid'}
        label={'Paid'}
        disabled={false}
      />

      <CheckboxField
        control={control}
        name={'finalized'}
        label={'Finalized'}
      />
    </Flex>
  )
}

export default InvoiceActionFields